<template>
  <div class="page-content">
    <page-breadcrumb title="Topics" class="mb-2" />

    <data-create-popup title="Create Group"
      :schema="create_schema" :default-data="{title: '', thumbnail: null, topic_type: 1, display_order: total}"
      :create-data-fn="createItem" @create="$refs.group_list.getList()"
    />
    <data-table-ssr id="group_list" ref="group_list"
      :columns="fields" :get-list-fn="getList"
      :to-edit-fn="toEditPage"
    />
  </div>
</template>

<script>
import service from '../service'
import { TOPIC_TYPE_OPTIONS } from '../constant';

const create_schema = [
  {
    cols: 4,
    fields: [
      { label: 'Thumbnail', field: 'thumbnail', input_type: 'image', validate: { required: true } },
    ]
  },
  {
    cols: 8,
    fields: [
      { label: 'Title', field: 'title', validate: { required: true } },
      { label: 'Type', field: 'topic_type', input_type: 'select', options: TOPIC_TYPE_OPTIONS },
      { label: 'Display order', field: 'display_order', validate: { required: true }}
    ]
  }
];

const fields = [
  { label: 'Thumbnail', field: 'thumbnail', input_type: 'image' },
  { label: 'Title', field: 'title' },
  { label: 'Type', field: 'topic_type', input_type: 'select', options: TOPIC_TYPE_OPTIONS },
  { label: 'Created At', field: 'createdAt', input_type: 'datetime' },
];

export default {
  data(){
    return{
      create_schema,
      fields,
      total: 0,
    }
  },
  methods:{
    async createItem(data) {
      let new_item = await service.create({ ...data });
      return new_item;
    },
    async getList({ limit, page, query }) {
      let response_data = await service.getList({
        query: JSON.stringify({ ...query }),
        page, limit
      });
      let list = [], total = 0;
      if (response_data) {
        list = response_data.list;
        total = response_data.total;
        this.total = total;
      }
      return { list, total };
    },
    toEditPage({ _id }) {
      this.$router.push({ name: 'social-topic-detail', params: { id: _id } });
    },
  }
}
</script>
